// src/pages/User/NewRequest/ui/steps/review/ReviewStepMobile.tsx
import React from "react";

import { Box, Card, Chip, Divider, Typography } from "@mui/material";

import { formatBRL } from "@utils/currency";

import { paymentLabel, useReviewStep } from "../../hook/useReviewStep";
import { formatQty } from "../../hook/useProductsStep";

export function ReviewStepMobile() {
  const { state } = useReviewStep();

  return (
    <Box sx={{ display: "grid", gap: 2 }}>
      <Typography variant="h6" fontWeight={800} textAlign="center">
        Resumo dos produtos
      </Typography>
      {state.cart.map((it) => (
        <Card key={it.id} variant="outlined" sx={{ borderRadius: 3, p: 2 }}>
          <Typography fontWeight={900} textAlign="center">
            {it.description}
          </Typography>

          <Typography
            variant="caption"
            sx={{ display: "block", textAlign: "center", opacity: 0.75 }}
          >
            Código: {it.code}
          </Typography>

          <Divider sx={{ my: 1.5 }} />

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1.2fr auto 1.3fr",
              gap: 0.4,
              alignItems: "start",
            }}
          >
            {/* Coluna 1: Esquerda */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  opacity: 0.7,
                  lineHeight: 1.2,
                  mb: 0.8,
                }}
              >
                Forma de pagamento
              </Typography>
              <Chip
                size="small"
                label={paymentLabel(it.payment, it.deadlinePayment)}
                sx={{
                  height: 24,
                  fontSize: "1rem",
                }}
              />
            </Box>

            {/* Coluna 2: Centro */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="caption"
                sx={{ opacity: 0.7, lineHeight: 1.2, mb: 0.8 }}
              >
                Quantidade (L)
              </Typography>
              <Typography fontWeight={900} variant="body1">
                {formatQty(it.quantity)}
              </Typography>
            </Box>

            {/* Coluna 3: Direita */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <Typography
                variant="caption"
                sx={{ opacity: 0.7, lineHeight: 1.2, mb: 0.8 }}
              >
                Subtotal
              </Typography>
              <Typography fontWeight={900} variant="body1" color="success.main">
                {formatBRL(it.subtotal, { fractionDigits: 2 })}
              </Typography>
            </Box>
          </Box>
        </Card>
      ))}

      <Divider sx={{ my: 1 }} />

      <Typography>
        Quantidade total do pedido:{" "}
        <strong>{formatQty(state.totals.totalQuantity)} litros</strong>
      </Typography>
      <Typography>
        Preço total do pedido:{" "}
        <strong>{formatBRL(state.totals.totalPrice)}</strong>
      </Typography>
    </Box>
  );
}
